import { alertsConstants } from '../constants/alerts';

const initialState = {
  alerts: [],
  messages: [],
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case alertsConstants.OPEN_ALERT:
      return {
        ...state,
        alerts: [
          ...state.alerts,
          {
            ...action.params,
            id: new Date().getTime(),
          },
        ]
      };
    case alertsConstants.CLOSE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter(alert => {
          if (alert.id === action.id) {
            return false;
          } else {
            return true;
          }
        })
      };
    case alertsConstants.SET_MESSAGES:
      return {
        ...state,
        messages: action.messages,
      };
    case alertsConstants.MESSAGE_HAS_BEEN_READ:
      return {
        ...state,
        messages: state.messages.filter(({ id }) => id !== action.id),
      };
    default:
      return state;
  }
};
